import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateMarketing = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 596.48 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:#002f75;}.d{fill:#fafcff;}.e{fill:#fff1d6;}.f{fill:#940a0a;}.g{fill:#9ec5ff;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "d",
				cx: 299.54,
				cy: 253.53,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 439.02,
						cy: 256.51,
						r: 17.17
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M428.57,347.71l-165.64-43.05v-96.3l165.64-43.05c8.47-2.2,16.96,4.04,17.05,12.79,0,.08,0,.17,0,.25v156.32c0,.08,0,.17,0,.25-.09,8.75-8.58,15-17.05,12.79Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M262.93,304.66h-46.68c-3.02,0-5.47-2.45-5.47-5.47v-85.36c0-3.02,2.45-5.47,5.47-5.47h46.68"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M217.66,297.96h38.38v73.6c0,2.42-1.96,4.38-4.38,4.38h-29.63c-2.42,0-4.38-1.96-4.38-4.38v-73.6h0Z"
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "c",
					d: "M256.35,54.85h-122.33c-4.19,0-7.59,3.4-7.59,7.59v74.64c0,4.19,3.4,7.59,7.59,7.59h71.74c6.57,10.93,17.55,13.51,23.26,14.09,1.24,.13,1.97-1.37,1.1-2.27-4.02-4.17-5.77-8.28-6.39-11.82h32.62c4.19,0,7.59-3.4,7.59-7.59V62.44c0-4.19-3.4-7.59-7.59-7.59Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M141.62,90.27h107.12c1.17,0,2.11,.77,2.11,1.72h0c0,.95-.95,1.72-2.11,1.72h-107.12c-1.17,0-2.11-.77-2.11-1.72h0c0-.95,.95-1.72,2.11-1.72Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M141.62,104.75h107.12c1.17,0,2.11,.77,2.11,1.72h0c0,.95-.95,1.72-2.11,1.72h-107.12c-1.17,0-2.11-.77-2.11-1.72h0c0-.95,.95-1.72,2.11-1.72Z"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "d",
						x: 139.5,
						y: 119.24,
						width: 48.8,
						height: 3.44,
						rx: 1.72,
						ry: 1.72
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "d",
						x: 139.5,
						y: 75.79,
						width: 111.35,
						height: 3.44,
						rx: 1.72,
						ry: 1.72
					})
				] })] }),
				/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M163.83,134.45H41.5c-4.19,0-7.59,3.4-7.59,7.59v44.64c0,4.19,3.4,7.59,7.59,7.59h91.74c6.57,10.93,17.55,13.51,23.26,14.09,1.24,.13,1.97-1.37,1.1-2.27-4.02-4.17-5.77-8.28-6.39-11.82h12.62c4.19,0,7.59-3.4,7.59-7.59v-44.64c0-4.19-3.4-7.59-7.59-7.59Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M530.3,449.64h-68.43c-13.19,0-23.89-10.69-23.89-23.89s10.69-23.89,23.89-23.89h26.42l4.71-11.49c.6-1.77,3.09-1.77,3.69,0l4.71,11.49h28.9c13.19,0,23.89,10.69,23.89,23.89s-10.69,23.89-23.89,23.89Z"
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "d",
						cx: 467.68,
						cy: 425.63,
						r: 4.26
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "d",
						cx: 494.26,
						cy: 425.63,
						r: 4.26
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "d",
						cx: 520.83,
						cy: 425.63,
						r: 4.26
					})
				] })
			]
		})
	]
});
export default SvgEmptyStateMarketing;
